import { DateTime } from "luxon";

export interface FilterOption {
  label: string;
  accessor: string;
  labelWidth: number;
  options?: any[];
  value?: string;
  datePicker?: boolean;
  endDate?: DateTime;
  startDate?: DateTime;
  viewFilter?: boolean;
}

export enum FilterType {
  Default,
  DatePicker,
  TypeAhead,
}

export interface IFilters {
  label: string;
  accessor: string;
  filterType?: FilterType;
  labelWidth?: number;
  multiselect?: boolean;
  options: string[];
  value: string[] | string | null;
  hidden?: boolean;
  endDate?: DateTime | null;
  startDate?: DateTime | null;
}
